<template>
  <div class="main">
    <div v-if="isShow" class="costomize">
      <img style="width:100%;height:100%;" src="../../assets/img/401.png" />
    </div>
    <div v-else class="costomize">
      <div class="content">
        <div class="content_header">
          <div class="content_header_left">
            <img v-if="this.album_cover_resource_id == ''" class="header_img" :src="photo_default" />
            <img v-else class="header_img" :src="album_cover_resource_id" :onerror="errorImg" />
          </div>
          <div class="content_header_right">
            <div class="content_header_title">
              <span class="header_text">{{this.albumInfo.album_name}}</span>
              <span class="header_info">
                <span class="photo_count">{{this.albumInfo.album_photo_num ? this.albumInfo.album_photo_num : 0}}
                  张</span>
                <el-popover placement="bottom" width="370" trigger="click">
                  <p class="fs12 cl333 box">
                    <span class="cl999">描述:</span>
                    {{this.albumInfo.album_description}}
                  </p>
                  <p class="fs12 cl333 box">
                    <span class="cl999">权限:</span>
                    {{this.albumInfo.cn_album_permission}}
                  </p>
                  <p class="fs12 cl333 box">
                    <span class="cl999">时间:</span>
                    {{this.albumInfo.album_create_time}}创建 - {{this.albumInfo.album_update_time}}更新
                  </p>

                  <el-button class="fs14 cl999" type="text" slot="reference">
                    &nbsp;/ {{this.albumInfo.cn_album_permission}}
                    <i class="el-icon-arrow-down"></i>
                  </el-button>
                </el-popover>
              </span>
            </div>
            <div class="content_header_btn" v-if="userid == owner_id">
              <el-button class="fs14" size="mini" type="primary" icon="el-icon-upload"
                v-if="albumInfo.school_id == identity.school_id && identity.identity_status == 1"
                @click="uploadVisible = true, abort()">上传照片/视频</el-button>
              <el-button class="fs14 white_btn" size="mini" type="text" icon="el-icon-delete"
                @click="batch_deletion_btn">批量删除</el-button>
            </div>
          </div>
        </div>
        <div class="noDataMask" v-if="isView">当前相册没有照片/视频</div>
        <div class="itemWrap" v-else v-loading="loading">
          <div class="item" v-for="(item, i) in photoData" :key="item.photo_id">
            <el-checkbox v-model="item.isChecked" v-if="deleteMore"></el-checkbox>
            <div v-if="item.suffix == 'mp4' || item.suffix == 'mov'">
              <div class="photo_cover">
                <img class="video_cover" :src="item.photo_cover" :onerror="errorImg"
                  @click="videoPlayVisible = true, setVideoSrc(item)" />
                <div class="photo_option" v-if="userid == owner_id">
                  <div class="arrow">
                    <i class="el-icon-arrow-down"></i>
                    <div class="op_wrap">
                      <div class="op_item" @click="setCover(item)"
                        v-if="albumInfo.school_id == identity.school_id && identity.identity_status == 1">
                        <i class="el-icon-star-off"></i>
                        <span class="op_text">设为封面</span>
                      </div>
                      <div class="op_item" @click="movePhoto(item)"
                        v-if="albumInfo.school_id == identity.school_id && identity.identity_status == 1">
                        <i class="el-icon-rank"></i>
                        <span class="op_text">移动到相册</span>
                      </div>
                      <div class="op_item" @click="delBtn(item)">
                        <i class="el-icon-delete"></i>
                        <span class="op_text">删除</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="photo_title">{{item.photo_name}}</div>
              <div class="photo_time">{{item.photo_upload_time}}</div>
            </div>
            <div v-else>
              <div class="photo_cover">
                <img class="photo_img" v-if="item.photo_url == ''" :src="photo_default" />
                <el-image v-else class="photo_img" fit="cover" @click="sortImg(i)" :src="item.photo_url"
                  :preview-src-list="images"></el-image>
                <div :class="{'video_cover':!video_status}">
                  <i class="el-icon-video-play" v-if="!video_status"></i>
                </div>
                <div class="photo_option" v-if="userid == owner_id">
                  <div class="arrow">
                    <i class="el-icon-arrow-down"></i>
                    <div class="op_wrap">
                      <div class="op_item" @click="setCover(item)"
                        v-if="albumInfo.school_id == identity.school_id && identity.identity_status == 1">
                        <i class="el-icon-star-off"></i>
                        <span class="op_text">设为封面</span>
                      </div>
                      <div class="op_item" @click="movePhoto(item)"
                        v-if="albumInfo.school_id == identity.school_id && identity.identity_status == 1">
                        <i class="el-icon-rank"></i>
                        <span class="op_text">移动到相册</span>
                      </div>
                      <div class="op_item" @click="delAlbumVisible = true, delBtn(item)">
                        <i class="el-icon-delete"></i>
                        <span class="op_text">删除</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="photo_title">{{item.photo_name}}</div>
              <div class="photo_time">{{item.photo_upload_time}}</div>
            </div>
          </div>
        </div>
        <div class="bottom_btn" v-if="deleteMore">
          <el-button size="mini" type="primary" @click="delAllBtnOk">删除</el-button>
          <el-button size="mini" class="white_btn" @click="deleteMore = false">取消</el-button>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" @current-change="PageChange" :current-page="this.page"
          :page-size="this.pageSize" :total="this.count" :hide-on-single-page="true"></el-pagination>
      </div>
      <!-- 上传相片弹出框  -->
      <el-dialog class="move_box" title="上传预览" :visible.sync="uploadVisible" :closeOnClickModal="false" width="680px">
        <el-upload list-type="picture-card" :disabled="isClick" :on-preview="handlePictureCardPreview"
          :action="uploadUrl" :data="uploadData" :on-success="onSuccess" :on-progress="onProgress" :on-change="onChange"
          :on-remove="onRemove" :auto-upload="false" :before-upload="beforeUpload" accept=".jpg, .jpeg, .png, .mp4"
          ref="upload" multiple>
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" />
        </el-dialog>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="uploadOk()" :disabled="isDisabled">确定</el-button>
          <el-button class="white_btn" @click="uploadVisible = false, abort()">取消</el-button>
        </span>
      </el-dialog>
      <!-- 移动相片弹出框 -->
      <el-dialog class="move_box" title="选择相册" :visible.sync="moveVisible" width="630px">
        <div class="dialog_content">
          <div class="add_album">
            <div class="left" @click="addAlbumVisible = true, addBtn()">
              <div class="icon_add_wrap">
                <i class="el-icon-plus"></i>
              </div>
            </div>
            <div class="right">
              <p class="cl333 fs12" style=" line-height:48px;width:80px;">创建相册</p>
            </div>
          </div>
          <div ref="item" v-for="(item, key) in albumData" :key="key" class="item"
            @click="select_album(key + 1, item.album_id)">
            <div class="active" ref="active" :id="item.album_id"></div>
            <div class="left">
              <i class="album_bg_icon"></i>
            </div>
            <div class="right">
              <p class="title fs12 cl333">{{item.album_name}}</p>
              <p class="purview fs12 cl999">{{item.cn_album_permission}}</p>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-pagination background layout="prev, pager, next" @current-change="PageAlbumChange"
            :current-page="this.pageAlbum" :page-size="this.pageSize" :total="this.countAlbum"
            :hide-on-single-page="true"></el-pagination>
          <el-button type="primary" @click="moveVisible = false,moveBtnOk()">移动</el-button>
          <el-button class="white_btn" @click="moveVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 创建相册弹出框 -->
      <el-dialog class="add_album_box" title="创建相册" :visible.sync="addAlbumVisible" width="460px">
        <div class="dialog_content">
          <div class="left_title">
            <div class="title_text">相册名称:</div>
            <div class="title_text">相册描述:</div>
            <div class="title_text">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;权限:</div>
          </div>
          <div class="right_input">
            <el-input class="input_item album_name" v-model="album_name" placeholder="请输入相册名称" maxlength="20"
              show-word-limit></el-input>
            <el-input class="input_item album_description" type="textarea" :rows="2" placeholder="请输入相册描述"
              v-model="album_description" maxlength="200" show-word-limit></el-input>
            <el-select class="input_item album_select" v-model="album_permission" placeholder="请选择权限">
              <el-option v-for="item in album_permissionData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CreateAlbumBtnOk">确定</el-button>
          <el-button class="white_btn" @click="addAlbumVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 删除相片/视频弹出框 -->
      <el-dialog class="del_album_box" title="提示" :visible.sync="delAlbumVisible" width="370px">
        <p style="text-align: center;">确定删除该相册中的照片/视频！</p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="delAlbumVisible = false, delBtnOk()">确定</el-button>
          <el-button class="white_btn" @click="delAlbumVisible = false">取消</el-button>
        </span>
      </el-dialog>
      <!-- 视频弹出窗 -->
      <el-dialog class="video_box" title="提示" :visible.sync="videoPlayVisible" width="1200px">
        <div slot="title" class="dialog-title">
          <div class="left">
            <img :src="user_face" :onerror="errorFace" />
          </div>
          <div class="right" style="margin-left:15px;">
            <div class="title">{{photo_name}}</div>
            <div class="info">
              <div class="publisher">{{user_name}}</div>
              <div class="fs14 cl999">{{photo_upload_time}}</div>
            </div>
          </div>
        </div>
        <div class="videoWrap" v-if="videoPlayVisible">
          <video id="myVideo`" class="video-js vjs-default-skin vjs-big-play-centered vjs-fluid" preload="auto" autoplay
            style="width: 1200px;height: 640px;" controls ref="video" @keyup="video_key" data-setup="{}"
            :src="this.video_src"></video>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import "videojs-flash";
export default {
  name: "photo_album",
  data() {
    return {
      errorImg: 'this.src="' + require("../../assets/img/damage.png") + '"', // 图片损坏默认图
      errorFace:
        'this.src="' + require("../../assets/img/menu_mine_on@3x.png") + '"', // 图片损坏默认图
      uploadUrl: "", // 文件上传地址
      uploadData: {
        UserId: "",
        SessionKey: "",
        OS: "",
        CheckCode: "",
        VideoSnapshot: "",
      },
      album_permissionData: [
        {
          value: "1",
          label: "公开",
        },
        {
          value: "4",
          label: "本校",
        },
        {
          value: "0",
          label: "不公开",
        },
      ],
      page: 1,
      pageAlbum: 1,
      pageSize: 25,
      count: 0,
      countAlbum: 0,
      user_name: "", // 作者
      user_face: "", // 头像
      photoData: [], //相片列表
      album_id: "", // 相册id
      album_name: "", // 相册名称
      album_description: "", // 相册描述
      album_permission: "", // 相册权限
      photo_name: "", // 相片名称
      photos_resource_id_list: "", // 相片路径
      photo_cover: "", // 视频封面
      photo_upload_time: "", // 上传时间
      video_status: true,
      video_src: "", // 视频地址
      addAlbumVisible: false,
      delAlbumVisible: false,
      moveVisible: false,
      videoPlayVisible: false,
      uploadVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      isSelf: false, // 是否自己
      isShow: false, // 是否显示禁止权限页面
      isView: false, // 是否显示缺省页
      deleteMore: false, //设置批量删除复选框是否显示
      checked: false, // 设置批量删除复选框是否选中，开发时没用
      i: 0,
      isClick: false, // 是否允许点击删除
      isUpload: false, // 是否允许上传
      isDisabled: true, // 禁用确定按钮(默认禁止)
      timer: null, // 定时器名称
      allowFormat: ["mp4", "jpg", "jpeg", "png"], // 允许上传的格式
      maxSize: 200, // 最大上传大小(单位:m)
      albumData: [], // 相册数据
      albumInfo: [], // 某个相册数据
      images: [], // 放大图片的列表
      photo_default: require("../../assets/img/no_photo.png"), // 相册默认封面
      video_default: require("../../assets/img/video_default_icon.png"), // 视频默认封面图
      album_cover_resource_id: "", // 封面图
      userid: 1,
      identity: "",
      role: "",
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      owner_id: 0,
      loading: false,
    };
  },

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  mounted() {
    this.playVideo();
  },

  methods: {
    init() {
      this.owner_id = this.$route.query.userid; // 学生空间id
      this.album_id = this.$route.query.album_id; // 相册id

      if (this.owner_id == undefined) {
        this.$router.push("error");
        return false;
      }

      this.GetAlbumInfo(); // 获取某个相册信息
      this.GetAlbumPhotos(); // 获取获取某个相册图片
      this.getLoginUserInfo(); // 获取登陆者信息
    },
    // 自动检测封面
    checkCover() {
      // 如果该相册没有封面并且相册里面有相片
      var album_cover_resource_id = this.albumInfo.album_cover_resource_id;
      var count = this.count;

      if (album_cover_resource_id == false && count > 0) {
        if (
          this.photoData[0].suffix == "mp4" ||
          this.photoData[0].suffix == "mov"
        ) {
          this.album_cover_resource_id = this.photoData[0].photo_thumb_resource_id; // 视频封面
        } else {
          this.album_cover_resource_id = this.photoData[0].photo_resource_id; // 相册地址
        }
        this.photo_id = this.photoData[0].photo_id;
        this.SetAlbumCover();
      } else {
        this.album_cover_resource_id = this.albumInfo.album_cover_resource_id;
      }
    },

    // 点击图片放大
    sortImg(index) {
      let photo_list = [];
      for (let i = 0; i < this.photoData.length; i++) {
        if (
          this.photoData[i]["suffix"] == "mp4" ||
          this.photoData[i]["suffix"] == "mov"
        ) {
          photo_list.push(this.photoData[i].photo_cover);
        } else {
          photo_list.push(this.photoData[i].photo_url);
        }
      }

      let tmp = photo_list.slice(index);
      tmp = tmp.concat(photo_list.slice(0, index));
      this.images = tmp;
    },

    // 获取用的登录数据并存入localStorage
    async getLoginUserInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      if (isLogin) {
        this.userid = this.websiteSessionInfo.userid;
        this.isSelf = this.userid == this.owner_id;
        this.uploadUrl = globalApi.GetWebHost("upload"); // 文件上传地址
      }
      this.GetIdentity(); // 获取身份
    },

    // 设置视频地址
    setVideoSrc(val) {
      this.video_src = val.photo_url; // 视频地址
      this.photo_name = val.photo_name; // 视频名称
      this.photo_upload_time = val.photo_upload_time; // 上传时间
      this.user_name = val.user_name; // 作者
      this.user_face = val.user_face; // 头像
    },

    // 分页导航(相片列表分页)
    PageChange(val) {
      this.page = val;
      document.documentElement.scrollTop = 0;
      this.GetAlbumPhotos();
    },

    // 分页导航(相册列表分页)
    PageAlbumChange(val) {
      this.pageAlbum = val;
      this.GetAlbumList();
    },

    playVideo() {
      var videoPlayer = videojs("myVideo", {
        muted: false,
        controls: true,
        autoplay: true,
        loop: true,
        techOrder: ["html5", "flash"],
        width: "1200",
        height: "640",
      });
    },

    // 点击相册高亮
    select_album(id, destination_album_id) {
      let items = this.$refs.item;
      for (let i = 0; i < items.length; i++) {
        this.$refs.item[i].style.border = "1px solid transparent";
        this.$refs.active[i].style.display = "none";
      }
      this.$refs.item[id - 1].style.border = "1px solid #08f";
      this.$refs.active[id - 1].style.display = "block";
      this.destination_album_id = destination_album_id; // 移动后的相册
    },

    // 获取某个相册信息接口
    async GetAlbumInfo() {
      const data = {
        s: "WebClassSpace.Photo.GetAlbumInfo",
        album_id: this.album_id, // 相册id
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      this.albumInfo = res.data.data.info;
      this.album_cover_resource_id = this.albumInfo.album_cover_resource_id;
      // this.checkCover(); // 自动检测封面

      this.GetAuth(); // 获取权限
    },

    // 获取某个相册图片接口
    async GetAlbumPhotos() {
      this.loading = true;
      const data = {
        s: "WebClassSpace.Photo.GetAlbumPhotos",
        album_id: this.album_id, // 相册id
        page: this.page,
        page_size: this.pageSize,
      };
      const res = await globalApi.post(data);
      this.loading = false;
      const response = res.data.data.result;

      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      this.photoData = res.data.data.photos;
      this.count = res.data.data.record_count;
      var page_count = res.data.data.page_count; // 最大页数
      this.count == 0 ? (this.isView = true) : (this.isView = false);
      // this.checkCover(); // 自动检测封面
      if (this.page > page_count) {
        this.page = this.page - 1;
        this.GetAlbumPhotos();
      }
    },

    // 上传相片接口
    async UploadPhotos() {
      const data = {
        s: "WebClassSpace.Photo.UploadPhotos",
        album_id: this.album_id, // 相册id
        photo_name: this.photo_name, // 相片名称
        photos_resource_id_list: this.photos_resource_id_list, // 相片路径
        photo_cover: this.photo_cover, // 视频封面
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }

      if (response == 1) {
        this.$message.success("上传成功!");
        this.setTimer(); // 刷新页面
      } else {
        this.$message.error("上传失败!");
      }
    },

    // 获取相册列表接口
    async GetAlbumList() {
      const data = {
        s: "WebClassSpace.Photo.GetAlbumList",
        creator_id: this.owner_id, // 教师空间id
        school_id: this.identity.school_id, // 学校id
        album_type: 3, // 类型-教师空间
        page: this.pageAlbum,
        page_size: this.pageSize,
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      this.albumData = res.data.data.album_list;
      this.countAlbum = res.data.data.record_count;
      this.albumData.forEach((item, i, array) => {
        if (item.album_id == this.album_id) {
          this.albumData.splice(i, 1);
        }
      });
    },

    // 创建相册接口
    async CreateAlbum() {
      const data = {
        s: "WebClassSpace.Photo.CreateAlbum",
        album_type: 3, // 类型-教师空间
        album_name: this.album_name, // 相册名称
        album_description: this.album_description, // 相册描述
        album_permission: this.album_permission, // 相册权限
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }

      if (response == 1) {
        this.addAlbumVisible = false;
        this.$message.success("相册创建成功!");
        this.GetAlbumList();
      } else {
        this.$message.error("相册创建失败!");
      }
    },

    // 设置相册封面接口
    async SetAlbumCover() {
      const data = {
        s: "WebClassSpace.Photo.SetAlbumCover",
        album_id: this.album_id, // 相册id
        photo_id: this.photo_id, // 相片id
        album_cover_resource_id: this.album_cover_resource_id, // 相册地址
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }

      if (response == 1) {
        this.$message.success("设置相册封面成功!");
        this.GetAlbumInfo(); // 重新获取某个相册信息
      } else {
        this.$message.error("设置相册封面失败!");
      }
    },

    // 移动相片到某个相册接口
    async MoveToAlbum() {
      const data = {
        s: "WebClassSpace.Photo.MoveToAlbum",
        photo_id: this.photo_id, // 相片id
        album_id: this.album_id, // 原相册id
        destination_album_id: this.destination_album_id, // 移动到的相册id
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }

      if (response == 1) {
        this.$message.success("相片移动成功!");
        this.GetAlbumPhotos(); // 重新获取相片列表
        this.GetAlbumInfo(); // 重新获取某个相册信息
      } else {
        this.$message.error("相片移动失败!");
      }
    },

    // 删除相册中的相片接口
    async DeletePhotoFromAlbum() {
      const data = {
        s: "WebClassSpace.Photo.DeletePhotoFromAlbum",
        photo_id: this.photo_id, // 相片id
        album_id: this.album_id, // 相册id
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }

      if (response == 1) {
        this.$message.success("相片删除成功!");
        this.GetAlbumPhotos(); // 重新获取图片列表
        this.GetAlbumInfo(); // 重新获取相册信息
        this.deleteMore = false;
      } else {
        this.$message.error("相片删除失败!");
      }
    },

    // 点击设置封面
    async setCover(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (val.suffix == "mp4" || val.suffix == "mov") {
        this.album_cover_resource_id = val.photo_thumb_resource_id; // 视频封面
      } else {
        this.album_cover_resource_id = val.photo_resource_id; // 相册地址
      }
      this.photo_id = val.photo_id;
      this.SetAlbumCover();
    },

    // 点击移动相册
    async movePhoto(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.$refs.active != undefined) {
        let items = this.$refs.item;
        for (let i = 0; i < items.length; i++) {
          this.$refs.item[i].style.border = "1px solid transparent";
          this.$refs.active[i].style.display = "none";
        }
      }
      this.moveVisible = true;
      this.photo_id = val.photo_id;
      this.GetAlbumList(); // 获取相册列表
    },

    // 点击创建相册
    async addBtn() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.album_name = ""; // 相册名称
      this.album_description = ""; // 相册描述
      this.album_permission = ""; // 相册权限
    },

    // 确认创建相册
    CreateAlbumBtnOk() {
      if (this.album_name == false) {
        this.$message.error("相册名称不能为空!");
        return false;
      }
      if (this.album_permission == "") {
        this.$message.error("请选择权限!");
        return false;
      }
      this.CreateAlbum();
    },

    // 点击确定上传按钮
    async uploadOk() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.isDisabled = true; // 禁止点击确定
      this.isClick = true; // 禁止点击删除
      this.$refs.upload.submit(); // 开始上传
    },

    // 点击移动确定
    moveBtnOk() {
      this.MoveToAlbum();
    },

    // 点击删除(单个删除)
    async delBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.delAlbumVisible = true;
      this.photo_id = val.photo_id;
    },

    // 点击确认删除(单个删除)
    delBtnOk() {
      this.DeletePhotoFromAlbum();
    },

    // 点击批量删除操作
    async batch_deletion_btn() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      // 再次点击批量删除时,清空之前所选的值
      var photoData = this.photoData;
      Object.keys(photoData).forEach(function (key) {
        photoData[key]["isChecked"] = false;
      });

      if (this.deleteMore == true) {
        this.deleteMore = false;
      } else {
        this.deleteMore = true;
      }
    },

    // 批量删除确定操作
    delAllBtnOk() {
      var photoData = this.photoData;
      var photo_id = Array();
      Object.keys(photoData).forEach(function (key) {
        if (photoData[key].isChecked == true) {
          photo_id.push(photoData[key].photo_id);
        }
      });
      if (photo_id == false) {
        this.$message.warning("请选择相片!");
        return false;
      }
      this.photo_id = photo_id;
      this.delAlbumVisible = true;
    },

    // 1秒后重新刷新页面
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          location.reload();
        }, 1000);
      }
    },

    //视频进度操作
    video_key(key) {
      let video = this.myPlayer;
      if (key.keyCode == 37) {
        video.currentTime(video.currentTime() - 10);
      } else if (key.keyCode == 39) {
        video.currentTime(video.currentTime() + 10);
      } else if (key.keyCode == 32) {
        if (!video.paused()) {
          video.pause();
        } else if (video.paused()) {
          video.play();
        }
      }
    },

    // 获取权限
    async GetAuth() {
      const data = {
        s: "Common.Auth.getAuth",
        operator_id: this.userid, // 登陆者id
        user_id: this.owner_id, // 空间id
      };

      const res = await globalApi.post(data);
      this.role = res.data.data;
      this.CheckAuth(); // 检查权限
    },

    // 获取身份
    async GetIdentity() {
      const data = {
        s: "Common.Auth.getIdentity",
        user_id: this.userid, // 登陆者id
      };

      const res = await globalApi.post(data);
      this.identity = res.data.data;
    },

    // 检查权限
    CheckAuth() {
      var owner_id = this.owner_id;
      var userid = this.userid;
      var album_permission = this.albumInfo.album_permission;

      if (
        album_permission == 1 ||
        (album_permission == 0 && owner_id == userid) ||
        (album_permission == 2 && this.role.isClass == true) ||
        (album_permission == 4 && this.role.isSchool == true) ||
        (album_permission == 6 && this.role.isCity == true)
      ) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },

    // **上传相关**

    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // 上传文件之前的钩子
    beforeUpload(file) {
      this.isDisabled = false; // 允许点击确定
      const _vm = this;
      _vm.uploadData.UserId = this.userid;
      _vm.uploadData.SessionKey = this.websiteSessionInfo.sessionKey;
      _vm.uploadData.OS = 4;
      _vm.uploadData.CheckCode = globalApi.randomString(40);
      _vm.uploadData.VideoSnapshot = 1; // 上传的视频文件是否截图 1-截图 0-不截图 默认不截图
      var format = file.name.split(".").pop().toLowerCase(); // 用户上传的文件格式
      var exp = new RegExp(format);
      if (!exp.test(this.allowFormat)) {
        this.$message.warning("请上传有效文件格式!");
        return false;
      }
    },

    // 文件上传时的钩子
    onProgress(event, file, fileList) {
      this.isDisabled = true; // 禁止点击确认
      if (event.percent == 100) {
        this.i++;
      }
      if (this.i == fileList.length) {
        this.isUpload = true;
      }
    },

    // 检查文件大小
    checkFileSize(fileList) {
      var i;
      for (i = 0; i < fileList.length; i++) {
        if (fileList[i]["size"] >= this.maxSize * 1024 * 1024) {
          this.$message.warning(
            fileList[i]["name"] + " 文件大小不能大于" + this.maxSize + "M!"
          );
          this.abort(); // 取消上传
          return false;
        }
      }
    },

    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      this.isDisabled = true; // 禁止点击确认
      let that = this;
      let param = {};
      param.file = file.raw;
      //检验视频编码格式
      MediaInfo({ format: "object" }, (mediainfo) => {
        globalApi.onChangeFileForElement(mediainfo, param, that);
      });
      console.log(file.status);
      // 如果是上传状态才允许确定
      if (file.status == "ready") {
        this.isDisabled = false; // 允许点击确定
      }
      this.checkFileSize(fileList); // 检查文件大小
      var format = file.name.split(".").pop().toLowerCase(); // 用户上传的文件格式

      // 给mp4格式默认图
      if (format == "mp4") {
        file.url = this.video_default;
      }
    },

    // 上传成功
    onSuccess(response, file, fileList) {
      let nameArr = Array();
      let urlArr = Array();
      let VideoCover = Array();
      if (response.Result) {
        for (let index = 0; index < fileList.length; index++) {
          nameArr.push(fileList[index].response.Data.Realname);
          urlArr.push(fileList[index].response.Data.Original);
          VideoCover.push(fileList[index].response.Data.VideoCover); // 视频封面
        }

        this.photo_name = nameArr; // 相片原名称
        this.photos_resource_id_list = urlArr; // 相片路径
        this.photo_cover = VideoCover; // 视频封面
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
      if (this.isUpload) {
        this.UploadPhotos();
      }
    },

    // 文件列表移除文件时的钩子
    onRemove(file, fileList) {
      if (fileList.length == 0) {
        this.isDisabled = true; // 禁止点击确定
      }
    },

    // 取消上传
    abort() {
      if (this.$refs.upload != undefined) {
        this.$refs.upload.clearFiles();
        this.$refs.upload.abort();
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/main.scss";
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-select-dropdown__item {
  color: #333;
}
</style>
<style lang="scss" scoped>
@import "../../assets/scss/main.scss";
.icon_add_album {
  background: url("../../assets/img/photo_establish_icon.png") no-repeat;
}
.icon_small {
  display: inline-block;
  font-size: 0;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
.main {
  width: 1200px;
  margin: 0 auto;
  font-size: 14px;
  color: #666666;
  .content {
    min-height: 620px;
    background: #fff;
    padding: 30px 20px 30px;
    position: relative;
    margin-top: 25px;
    .content_header {
      display: flex;

      .content_header_left {
        img {
          width: 69px;
          height: 69px;
        }
        margin-right: 20px;
      }
      .content_header_right {
        .content_header_title {
          .header_text {
            @include no-wrap();
            display: inline-block;
            width: 270px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
            line-height: 20px;
          }
        }
        .content_header_btn {
          display: flex;
          margin-top: 10px;
        }
      }
    }
    .noDataMask {
      background: url("../../assets/img/Album_icon_Photo.png.png") no-repeat
        center;
      height: 580px;
      text-align: center;
      font-size: 14px;
      color: #666;
      line-height: 796px;
    }
    .itemWrap {
      margin-top: 40px;
      display: flex;
      flex-wrap: wrap;
      .item:nth-child(5n) {
        margin: 0 0 30px 0;
      }
      .el-checkbox.item .item {
        margin: 0 15px 0 0;
      }
      .item {
        background: #eff2f3;
        box-sizing: border-box;
        width: 202px;
        margin: 0 37px 30px 0;
        position: relative;
        .el-checkbox {
          position: absolute;
          top: 0;
          left: 0;
        }
        .el-checkbox__label {
          padding-left: 0;
          height: 192px;
        }
        .photo_cover:hover {
          .arrow {
            display: block !important;
          }
        }

        .video_cover {
          width: 202px;
          height: 140px;
          cursor: pointer;
        }
        .photo_cover {
          width: 202px;
          height: 140px;
          border-radius: 2px;
          margin-left: 0 !important;
          position: relative;
          .photo_img {
            width: 202px;
            height: 140px;
            border-radius: 2px;
            margin-left: 0 !important;
            cursor: pointer;
          }
          .photo_option {
            padding: 0 8px;
            // display: none;
            color: #08f;
            .el-icon-arrow-down:before {
              font-size: 16px;
              font-weight: bold;
            }
            .arrow:hover {
              .op_wrap {
                display: block;
              }
            }
            .arrow {
              position: absolute;
              top: 4px;
              right: 4px;
              border-radius: 2px;
              background: #fff;
              width: 24px;
              height: 24px;
              text-align: center;
              display: none;
              box-sizing: border-box;
              padding-top: 5px;
              .op_wrap {
                display: none;
                position: absolute;
                top: 24px;
                right: 0px;
                border-radius: 4px;
                background: #fff;
                width: 100px;
                .op_item:hover {
                  color: #fff;
                  background: #08f;
                  border-radius: 4px;
                }
                .op_item {
                  text-align: center;
                  padding: 9px 0;
                }
                .op_text {
                  margin-left: 10px;
                }
              }
            }
          }
        }
        .photo_title {
          @include no-wrap();
          margin: 8px;
          font-size: 14px;
          color: #333;
          font-weight: bold;
          line-height: 2;
        }
        .photo_time {
          margin: 8px;
          font-size: 14px;
          color: #333;
          line-height: 1;
        }
      }
    }
    .bottom_btn {
      position: absolute;
      bottom: 10px;
      left: 20px;
    }
  }
  .move_box {
    .el-dialog {
      .el-dialog__body {
        padding: 20px 20px 20px;
      }
      .dialog_content {
        display: flex;
        flex-wrap: wrap;
        .item:hover {
          border: 1px solid rgba(0, 136, 255, 1) !important;
        }
        .item:nth-child(4n) {
          margin-left: 0px;
        }
        .item:nth-child(1) {
          margin-left: 0px;
        }
        .add_album {
          margin-left: 0px !important;
        }
        .add_album,
        .item {
          position: relative;
          display: flex;
          width: 138px;
          height: 50px;
          border: 1px solid transparent;
          border-radius: 2px;
          margin-left: 10px;
          margin-bottom: 10px;
          .active {
            display: none;
            z-index: 99;
            position: absolute;
            top: 0;
            left: 0;
            height: 16px;
            width: 16px;
            background: url("../../assets/img/check_opt_icon.png");
          }
          .left {
            margin-right: 8px;
            .icon_add_wrap {
              width: 50px;
              height: 50px;
              background: #f5f5f5;
              text-align: center;
              line-height: 50px;
              font-size: 20px;
              color: #c3c4cc;
              cursor: pointer;
            }
            .album_bg_icon {
              background: url("../../assets/img/icon-img-Evaluate.png")
                no-repeat;
              background-size: 50px 50px;
              height: 50px;
              width: 50px;
              display: block;
            }
          }
          .right {
            .title {
              @include no-wrap();
              width: 82px;
              line-height: 2;
            }
            .purview {
              line-height: 2;
            }
          }
        }
      }
    }
  }
  .select_album_box {
    .el-dialog__body {
      padding: 20px 20px 40px;
    }
    .dialog_content {
      display: flex;
      margin: 0 30px;
      justify-content: center;

      .left_title {
        .title_text {
          width: 69px;
          margin-right: 10px;
          font-size: 16px;
          color: #666666;
          margin: 6px 10px 32px 0;
        }
        .title_text:nth-child(2) {
          margin-bottom: 57px;
        }
      }
      .right_input {
        .input_item {
          width: 258px;
          margin-bottom: 20px;
        }
        .album_description {
          width: 258px;
        }
        .album_select {
          width: 258px;
        }
      }
    }
  }
  .add_album_box {
    .el-dialog__body {
      padding: 20px 20px 40px;
    }
    .dialog_content {
      display: flex;
      margin: 0 30px;
      justify-content: center;

      .left_title {
        .title_text {
          width: 69px;
          margin-right: 10px;
          font-size: 16px;
          color: #666666;
          margin: 6px 10px 32px 0;
        }
        .title_text:nth-child(2) {
          margin-bottom: 57px;
        }
      }
      .right_input {
        .input_item {
          width: 258px;
          margin-bottom: 20px;
        }
        .album_description {
          width: 258px;
        }
        .album_select {
          width: 258px;
        }
      }
    }
  }
  .video_box {
    .el-dialog__header {
      padding: 10px 20px;
      .dialog-title {
        display: flex;
        .left {
          width: 80px;
          height: 80px;
          img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
          }
        }
        .right {
          .title {
            font-size: 24px;
            color: #333;
            @include no-wrap();
            line-height: 2;
          }
          .info {
            line-height: 2;
            display: flex;
            .publisher {
              @include no-wrap();
              color: #08f;
              font-size: 14px;
              margin-right: 20px;
              max-width: 112px;
            }
          }
        }
      }
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
<style scoped>
.ui_button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
}
.ui_button_primary {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  border-radius: 3px;
  padding: 7px 15px;
  font-size: 14px;
}
label.ui_button:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}
.el-dialog__title {
  color: #666;
  font-size: 14px;
  line-height: 12px;
}
.el-dialog__header {
  background: rgba(246, 249, 250, 1);
  border: 1px solid rgba(246, 249, 250, 1);
  border-radius: 2px 2px 0px 0px;
}
.op_text {
  cursor: pointer;
}
.box {
  margin-bottom: 5px;
}
</style>
<style lang="scss">
.el-icon-circle-close {
  color: #ffffff;
}
.video_box {
  .el-dialog {
    margin-top: 6vh !important;
  }
}
</style>


